import styled, { css } from 'styled-components';
import { EmptyStateCard } from '@edapp/ed-components';

export const StyledEmptyStateCard = styled(EmptyStateCard)(
  ({ theme }) => css`
    padding-bottom: ${theme.space(12)}px;
    white-space: normal;
  `
);
